/**
 * Constants + label lookups shared by ZoneEditor and its future
 * sub-components. Extracted from the top of ZoneEditor.jsx during
 * the iter-38 refactor to keep the main file focused on state/logic.
 */

/** Zoom limits for the pan-zoom canvas. */
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 8;

/** Screen-space snap radius (px) when the cursor is near an existing
 *  polygon vertex. Generous so touch users don't have to be pixel-precise. */
export const VERTEX_SNAP_PX = 14;

/** Human labels for the per-zone `click_action` dropdown. */
export const ACTION_LABEL = {
  open_details: "Open unit / group details",
  show_info:    "Show info popover",
  goto_scene:   "Jump to another scene",
};

/** Predicate used across the editor to gate video-only affordances
 *  (playhead scrubber, poster-frame picker, etc.). */
export const isVideoScene = (s) =>
  !!s && (s.type === "loop_video" || s.type === "scrubbable" || s.type === "transition");

/** Phase B — CAD snap kinds. Which point-snap candidates are considered
 *  while drawing, persisted in localStorage. Perpendicular/extension are
 *  off by default (they get noisy on dense scenes). */
export const SNAP_KIND_DEFAULTS = {
  vertex: true,
  edge: true,
  midpoint: true,
  intersection: true,
  perpendicular: false,
  extension: false,
};

/** Short badge shown next to the snap marker so the user knows WHICH
 *  snap-kind grabbed the cursor (AutoCAD OSNAP convention). */
export const SNAP_KIND_LABEL = {
  vertex: "VTX",
  edge: "EDGE",
  midpoint: "MID",
  intersection: "INT",
  perpendicular: "PERP",
  extension: "EXT",
  guide: "GUIDE",
};
